import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewCozyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_cozy"}/>
}
